<template>
    <div>
        <div id="plugin-form" v-if="!user.global_admin">
            <h1>{{ t('places-details-access_denied') }}</h1>
        </div>
        <div id="plugin-form" v-if="error">
            <h1>{{ error }}</h1>
        </div>
        <div id="plugin-form" v-if="user.global_admin && error === null">
            <div class="container-fluid" v-if="is('ready')">
                <h2>{{ t('plugin') }}: {{ plugin }}</h2>
                <form @submit.prevent="save">
                    <div class="field">
                        <label>{{ t('external_id') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="external_id"
                        />
                    </div>

                    <div
                        class="field"
                        v-for="(setting, index) in settingKeys"
                        :key="index"
                    >
                        <!-- i18n-validator-ignore-next-line: displaying dynamic setting key from settingKeys -->
                        <label>{{ setting }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="settings[setting]"
                        />
                    </div>
                    <button class="btn btn-primary" :disabled="is('loading')">
                        {{ t('save') }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";

export default {
    props: {
        user: Object,
        plugin: String,
    },
    data: function () {
        return {
            state: "ready",
            settings: {},
            external_id: null,
            error: null,
        };
    },
    async mounted() {
        if (this.plugin) {
            await this.getSettings();
            this.setState("ready");
        }
    },
    computed: {
        settingKeys() {
            return Object.keys(this.settings);
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        setState: function (state) {
            this.state = state;
        },
        is: function (state) {
            return state === this.state;
        },
        async getSettings() {
            this.setState("loading");
            try {
                const options = keviApi.getOptions("plugins/settings", "GET", {
                    plugin: this.plugin,
                    id:  this.$route.query.id ?? null
                });
                const response = await this.$http(options);
                if (response) {
                    this.external_id = response.body.external_id;
                    this.settings = response.body.settings;
                }
            } catch (error) {
                if (error.body.error) {
                    this.error = error.body.error;
                } else {
                    this.error = this.t('internal_server_error');
                }
            }
        },
        save: function () {
            this.setState("loading");
            let options = keviApi.getOptions("plugins/settings", "POST", {
                plugin: this.plugin,
                settings: this.settings,
                external_id: this.external_id,
                id:  this.$route.query.id ?? null
            });
            this.$http(options).then((response) => {
                this.$store.dispatch(
                    "notification/success",
                    this.t('places-plugins-settings_updated'),
                );
                this.setState("ready");
                this.$router.go(-1);
            });
        },
    },
};
</script>
